import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import { ClipLoader } from "react-spinners";

// import noDataFoundImg from '../../assets/img/404error.png'
import "../../routes/app";

// Styling
const center = {
  textAlign: "center",
};

const override = {
  display: "block",
  margin: "0 auto",
};

class PageNotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }
  render() {
    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 5000);
    return (
      <div>
        {this.state.loading ? (
          <div style={{ marginTop: "20%" }}>
            <ClipLoader
              css={override}
              size={150}
              color={"#a9a9a9"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          <div style={{ marginTop: "20%" }}>
            <Card
              content={
                <div style={center}>
                  <h1>404</h1>
                  <h3>Page Not Found</h3>
                  <h5>
                    The page you are looking for doesn't exist or another error
                    occured.
                  </h5>
                  <h6>
                    <a href="/dashboard">Return to HOME PAGE</a>
                  </h6>
                </div>
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default PageNotFound;
